import React from 'react';

/**
 * Icône pour la liste des événements
 * Design simple de liste avec lignes
*/
export const ListIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <path d="M8 14h.01" />
    <path d="M12 14h.01" />
    <path d="M16 14h.01" />
    <path d="M8 18h.01" />
    <path d="M12 18h.01" />
    <path d="M16 18h.01" />
  </svg>
);


/**
 * Icône pour créer un événement
 * Design de plus dans un cercle
 */
export const EventIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

/**
 * Icône de globe terrestre pour la carte (bouton central)
 * Design de globe avec méridiens et parallèles
 */
export const MapIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

/**
 * Icône pour mes événements
 * Design combinant favoris et gestion d'événements personnels
 */
export const MyEventsIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="9" y1="12" x2="15" y2="12" />
  </svg>
);

/**
 * Icône pour les paramètres
 * Design d'engrenage classique pour les réglages
 */
export const SettingsIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

/**
 * Icône de pièce de monnaie pour les crédits
 * Design de pièce avec globe terrestre en couleurs Maploop
 */
export const CoinIcon = ({ className = "w-6 h-6", style, ...props }) => {
  const baseColor = style?.color || 'rgb(40, 148, 216)';
  
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="10" fill={baseColor} stroke="rgb(19, 110, 157)" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="7" fill="rgb(7, 78, 108)" opacity="0.3" />
      <circle cx="12" cy="12" r="5" stroke="white" strokeWidth="1.2" fill="none" />
      <line x1="7" y1="12" x2="17" y2="12" stroke="white" strokeWidth="1.2" />
      <path 
        d="M12 7a7.5 7.5 0 0 1 2 5 7.5 7.5 0 0 1-2 5 7.5 7.5 0 0 1-2-5 7.5 7.5 0 0 1 2-5z" 
        stroke="white" 
        strokeWidth="1.2" 
        fill="none"
      />
    </svg>
  );
};

/**
 * Icône de recherche - Loupe
 * Design de loupe pour la recherche
 */
export const SearchIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11328)">
      <path d="M10.1485 19.44C15.2801 19.44 19.44 15.2801 19.44 10.1486C19.44 5.01709 15.2801 0.857178 10.1485 0.857178C5.01703 0.857178 0.857117 5.01709 0.857117 10.1486C0.857117 15.2801 5.01703 19.44 10.1485 19.44Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23.1428 23.1429L16.7143 16.7144" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11328">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône de flèche vers la droite pour la navigation
 * Design de flèche dans un cercle
 */
export const ArrowRightIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_10002)">
      <path d="M10.2857 6.85718L15.4286 12L10.2857 17.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84597 0.857178 0.857147 5.846 0.857147 12C0.857147 18.1541 5.84597 23.1429 12 23.1429Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_10002">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône de flèche vers la gauche pour la navigation
 * Design de flèche dans un cercle en couleurs Maploop
 */
export const ArrowLeftIcon = ({ className = "w-6 h-6", style, ...props }) => {
  const baseColor = style?.color || 'rgb(40, 148, 216)';
  
  return (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
<g clipPath="url(#clip0_1545_9930)">
<path d="M13.7143 6.85718L8.57141 12L13.7143 17.1429" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 23.1429C18.154 23.1429 23.1428 18.1541 23.1428 12C23.1428 5.846 18.154 0.857178 12 0.857178C5.84594 0.857178 0.857117 5.846 0.857117 12C0.857117 18.1541 5.84594 23.1429 12 23.1429Z" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1545_9930">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};
/**
 * Icône Culture - Monument historique
 */
export const CultureIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>

<path d="M22.1316 9.42846H1.86874C0.908737 9.42846 0.497308 8.38274 1.25159 7.8856L11.383 1.25131C11.5701 1.14128 11.7831 1.08325 12.0002 1.08325C12.2172 1.08325 12.4303 1.14128 12.6173 1.25131L22.7487 7.8856C23.503 8.38274 23.0916 9.42846 22.1316 9.42846Z"/>
<path d="M22.2857 18.8569H1.71428C1.2409 18.8569 0.85714 19.2407 0.85714 19.7141V22.2855C0.85714 22.7589 1.2409 23.1426 1.71428 23.1426H22.2857C22.7591 23.1426 23.1429 22.7589 23.1429 22.2855V19.7141C23.1429 19.2407 22.7591 18.8569 22.2857 18.8569Z"/>
<path d="M3.42857 9.42847V18.857"/>
<path d="M7.71428 9.42847V18.857"/>
<path d="M12 9.42847V18.857"/>
<path d="M16.2857 9.42847V18.857"/>
<path d="M20.5714 9.42847V18.857"/>

</svg>

);

/**
 * Icône Art - Pinceau artistique
 */
export const ArtIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>

<path d="M14.5714 8.57142C15.5182 8.57142 16.2857 7.80391 16.2857 6.85714C16.2857 5.91036 15.5182 5.14285 14.5714 5.14285C13.6246 5.14285 12.8571 5.91036 12.8571 6.85714C12.8571 7.80391 13.6246 8.57142 14.5714 8.57142Z"/>
<path d="M7.71426 17.1428C8.18765 17.1428 8.5714 16.7591 8.5714 16.2857C8.5714 15.8123 8.18765 15.4286 7.71426 15.4286C7.24087 15.4286 6.85712 15.8123 6.85712 16.2857C6.85712 16.7591 7.24087 17.1428 7.71426 17.1428Z"/>
<path d="M7.71429 11.1429C8.66106 11.1429 9.42857 10.3753 9.42857 9.42856C9.42857 8.48179 8.66106 7.71428 7.71429 7.71428C6.76751 7.71428 6 8.48179 6 9.42856C6 10.3753 6.76751 11.1429 7.71429 11.1429Z"/>
<path d="M16.32 21.0514C16.3009 20.7189 16.1854 20.3992 15.9875 20.1312C15.7896 19.8633 15.5179 19.6589 15.2057 19.5428C14.4304 19.288 13.7713 18.7649 13.3472 18.0677C12.923 17.3704 12.7614 16.5447 12.8916 15.7389C13.0217 14.9332 13.435 14.2003 14.0572 13.6721C14.6794 13.1439 15.4696 12.8549 16.2857 12.8571H19.4914C20.0413 12.8587 20.5834 12.7279 21.0721 12.476C21.5608 12.224 21.9817 11.8582 22.2994 11.4095C22.6171 10.9607 22.8222 10.4421 22.8973 9.89746C22.9725 9.3528 22.9156 8.79805 22.7314 8.27999C22.0496 6.3548 20.8518 4.65403 19.2688 3.3635C17.6858 2.07297 15.7786 1.24234 13.7555 0.962345C11.7324 0.682351 9.67127 0.963769 7.79728 1.77585C5.9233 2.58794 4.30856 3.89945 3.12947 5.56709C1.95039 7.23474 1.25232 9.19437 1.11153 11.2319C0.970745 13.2694 1.39266 15.3064 2.33117 17.1204C3.26969 18.9344 4.68871 20.4555 6.43319 21.5176C8.17767 22.5797 10.1805 23.1419 12.2229 23.1428C13.2315 23.1457 14.2355 23.0072 15.2057 22.7314C15.5621 22.6316 15.8707 22.407 16.0752 22.0986C16.2798 21.7902 16.3666 21.4185 16.32 21.0514V21.0514Z" />

</svg>

);

/**
 * Icône Music - Note de musique
 */
export const MusicIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

/**
 * Icône Theater - Rideaux ouverts
 */
export const TheaterIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3.03429 14.5714C1.62424 12.7839 0.8573 10.5737 0.857147 8.29707V2.7085C3.20698 1.49253 5.81419 0.85791 8.46 0.85791C11.1058 0.85791 13.713 1.49253 16.0629 2.7085" />
    <path d="M13.3543 23.0399C12.7544 23.1754 12.1309 23.1669 11.5349 23.0149C10.9389 22.863 10.3875 22.5719 9.92572 22.1656V22.1656C8.32158 20.7827 7.13371 18.9809 6.49492 16.9616C5.85614 14.9423 5.79162 12.7852 6.30858 10.7313L7.56001 5.72558C10.278 5.03625 13.1246 5.03252 15.8443 5.71471C18.5641 6.39689 21.072 7.74366 23.1429 9.63415L21.8914 14.6227C21.387 16.6784 20.3218 18.5538 18.8145 20.0399C17.3072 21.526 15.4169 22.5645 13.3543 23.0399V23.0399Z" />
    <path d="M9.61714 11.1598C9.8334 10.9335 10.1075 10.7707 10.4097 10.6891C10.7119 10.6076 11.0307 10.6103 11.3314 10.697C11.6258 10.7662 11.8967 10.9121 12.1164 11.1199C12.3362 11.3276 12.4971 11.5898 12.5829 11.8798" />
    <path d="M16.4057 12.857C16.6151 12.6321 16.881 12.4675 17.1757 12.3806C17.4705 12.2936 17.7832 12.2875 18.0811 12.3629C18.379 12.4382 18.6512 12.5923 18.8691 12.8089C19.0871 13.0255 19.2428 13.2967 19.32 13.5942" />
  </svg>
);

/**
 * Icône Cinema - Clap de cinéma
 */
// export const CinemaIcon = ({ className, ...props }) => (
//   <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="5" y="12" width="18" height="10" rx="1"/>
//     <rect x="5" y="10" width="18" height="3" fill="currentColor" />
//     <rect x="5" y="4" width="18" height="2" fill="currentColor" transform="rotate(-20 12 9.5)" />
//     <line x1="8" y1="5" x2="8" y2="7" strokeWidth="2" stroke="currentColor" />
//     <line x1="12" y1="4" x2="12" y2="6" strokeWidth="2" stroke="currentColor" />
//     <line x1="16" y1="2" x2="16" y2="4" strokeWidth="2" stroke="currentColor" />
//     <line x1="20" y1="1" x2="20" y2="3" strokeWidth="2" stroke="currentColor" />
//     <line x1="8" y1="10" x2="8" y2="11" strokeWidth="2" stroke="currentColor" />
//     <line x1="12" y1="10" x2="12" y2="11" strokeWidth="2" stroke="currentColor" />
//     <line x1="16" y1="10" x2="16" y2="11" strokeWidth="2" stroke="currentColor" />
//     <line x1="20" y1="10" x2="20" y2="11" strokeWidth="2" stroke="currentColor" />
//   </svg>
// );
export const CinemaIcon = ({ className, ...props }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
<path d="M6 11.1429C8.84033 11.1429 11.1429 8.84036 11.1429 6.00003C11.1429 3.15971 8.84033 0.857178 6 0.857178C3.15968 0.857178 0.857147 3.15971 0.857147 6.00003C0.857147 8.84036 3.15968 11.1429 6 11.1429Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18 11.1428C19.8935 11.1428 21.4286 9.60776 21.4286 7.71422C21.4286 5.82067 19.8935 4.28564 18 4.28564C16.1065 4.28564 14.5714 5.82067 14.5714 7.71422C14.5714 9.60776 16.1065 11.1428 18 11.1428Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M17.1429 15.4287H7.71429C6.76751 15.4287 6 16.1962 6 17.143V21.4287C6 22.3755 6.76751 23.143 7.71429 23.143H17.1429C18.0896 23.143 18.8571 22.3755 18.8571 21.4287V17.143C18.8571 16.1962 18.0896 15.4287 17.1429 15.4287Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M23.1429 17.1428V21.4285" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);
/**
 * Icône Festival - Drapeau festif
 */
// export const FestivalIcon = ({ className, ...props }) => (
//   <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
//     <line x1="4" y1="22" x2="4" y2="15" />
//   </svg>
// );
export const FestivalIcon = ({ className, ...props }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>

<path d="M20.3143 22.6286L8.86285 18.36C8.52388 18.2403 8.22047 18.0372 7.98056 17.7695C7.74065 17.5018 7.57195 17.178 7.48999 16.828C7.40804 16.478 7.41546 16.113 7.51157 15.7666C7.60768 15.4201 7.7894 15.1035 8.03999 14.8457L15.2228 7.66288C15.4882 7.41419 15.812 7.23651 16.1643 7.14633C16.5166 7.05615 16.886 7.05637 17.2382 7.14698C17.5904 7.2376 17.914 7.41566 18.179 7.66467C18.444 7.91369 18.6419 8.22558 18.7543 8.57145L23.0057 20.0229C23.1238 20.3939 23.136 20.7905 23.0409 21.168C22.9458 21.5455 22.7473 21.8891 22.4676 22.1599C22.1878 22.4307 21.8381 22.618 21.4577 22.7008C21.0772 22.7837 20.6813 22.7586 20.3143 22.6286V22.6286Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3.51428 12.2231C4.27554 11.7983 5.16702 11.67 6.01714 11.8631" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M7.42286 7.33728C6.93741 6.60544 6.73622 5.7214 6.85715 4.85156" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.3657 1.23438C10.7649 3.07496 10.8439 5.06998 11.5886 6.85723"  strokeLinecap="round" strokeLinejoin="round"/>
<path d="M1.71429 6.48015C2.18768 6.48015 2.57143 6.0964 2.57143 5.62301C2.57143 5.14963 2.18768 4.76587 1.71429 4.76587C1.2409 4.76587 0.857147 5.14963 0.857147 5.62301C0.857147 6.0964 1.2409 6.48015 1.71429 6.48015Z" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

/**
 * Icône Sport - Silhouette en mouvement
 */
export const SportIcon = ({ className, ...props }) => (
<svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" {...props}>
<g clipPath="url(#clip0_1545_11739)">
<path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84597 0.857178 0.857143 5.846 0.857143 12C0.857143 18.1541 5.84597 23.1429 12 23.1429Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 0.857178V23.1429" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3.6 19.3199C4.85612 18.5552 5.89436 17.4802 6.6149 16.1983C7.33544 14.9163 7.71404 13.4705 7.71428 11.9999C7.71404 10.5294 7.33544 9.08357 6.6149 7.80161C5.89436 6.51965 4.85612 5.44463 3.6 4.67993" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M20.4 4.67993C19.1443 5.44492 18.1065 6.52006 17.3864 7.802C16.6663 9.08394 16.2881 10.5296 16.2881 11.9999C16.2881 13.4703 16.6663 14.9159 17.3864 16.1979C18.1065 17.4798 19.1443 18.5549 20.4 19.3199" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1545_11739">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

);

/**
 * Icône Workshop - Outils
 */
export const WorkshopIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

/**
 * Icône Market - Panier d'achat
 */
export const MarketIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

/**
 * Icône Conference - Ampoule/Cerveau
 */
export const ConferenceIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
    <path d="M9 21h6" />
    <path d="M10 18h4" />
  </svg>
);

/**
 * Icône Nature - Feuille
 */
export const NatureIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
  </svg>
);

/**
 * Icône Family - Groupe de personnes
 */
export const FamilyIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

/**
 * Icône Reload - Rafraîchir
 */
export const ReloadIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10 16H5V21M14 8H19V3M4.58301 9.0034C5.14369 7.61566 6.08244 6.41304 7.29255 5.53223C8.50266 4.65141 9.93686 4.12752 11.4298 4.02051C12.9227 3.9135 14.4147 4.2274 15.7381 4.92661C17.0615 5.62582 18.1612 6.68254 18.9141 7.97612M19.4176 14.9971C18.8569 16.3848 17.9181 17.5874 16.708 18.4682C15.4979 19.3491 14.0652 19.8723 12.5723 19.9793C11.0794 20.0863 9.58606 19.7725 8.2627 19.0732C6.93933 18.374 5.83882 17.3175 5.08594 16.0239" />
  </svg>
);

/**
 * Icône Heart - Cœur
 */
export const HeartIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M19.2373 6.23731C20.7839 7.78395 20.8432 10.2727 19.3718 11.8911L11.9995 20.0001L4.62812 11.8911C3.15679 10.2727 3.21605 7.7839 4.76269 6.23726C6.48961 4.51034 9.33372 4.66814 10.8594 6.5752L12 8.00045L13.1396 6.57504C14.6653 4.66798 17.5104 4.51039 19.2373 6.23731Z" />
  </svg>
);

/**
 * Icône Building - Bâtiment
 */
export const BuildingIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 20H4M4 20H9M4 20V7.2002C4 6.08009 4 5.51962 4.21799 5.0918C4.40973 4.71547 4.71547 4.40973 5.0918 4.21799C5.51962 4 6.08009 4 7.2002 4H8.8002C9.9203 4 10.4796 4 10.9074 4.21799C11.2837 4.40973 11.5905 4.71547 11.7822 5.0918C12 5.5192 12 6.07899 12 7.19691V10.0002M9 20H20M9 20V14.3682C9 13.8428 9 13.58 9.063 13.335C9.11883 13.1178 9.21073 12.9118 9.33496 12.7252C9.47505 12.5147 9.67113 12.3384 10.0615 11.9877L12.3631 9.91997C13.1178 9.24192 13.4955 8.90264 13.9225 8.77393C14.2989 8.66045 14.7007 8.66045 15.0771 8.77393C15.5045 8.90275 15.8827 9.2422 16.6387 9.92139L18.9387 11.9877C19.3295 12.3388 19.5245 12.5146 19.6647 12.7252C19.7889 12.9118 19.8807 13.1178 19.9365 13.335C19.9995 13.58 20 13.8428 20 14.3682V20M20 20H22" />
  </svg>
);

/**
 * Icône Rain - Pluie
 */
export const RainIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M7.28571 19.7143L8.14285 18" />
    <path d="M15 19.7143L15.8571 18" />
    <path d="M10.2857 23.1428L11.1428 21.4285" />
    <path d="M2.57144 23.1428L3.42858 21.4285" />
    <path d="M18 23.1428L18.8571 21.4285" />
    <path d="M18.8571 13.7143C19.4663 13.7161 20.0687 13.588 20.6245 13.3386C21.1802 13.0892 21.6763 12.7242 22.0799 12.268C22.4834 11.8117 22.7851 11.2747 22.9648 10.6927C23.1444 10.1107 23.198 9.49709 23.1218 8.89276C23.0456 8.28843 22.8415 7.70728 22.5231 7.18804C22.2047 6.6688 21.7792 6.22341 21.2751 5.88154C20.771 5.53968 20.1998 5.3092 19.5995 5.20548C18.9993 5.10175 18.3839 5.12716 17.7943 5.28C17.4516 4.00529 16.6982 2.87915 15.6506 2.07604C14.6031 1.27292 13.32 0.837646 12 0.837646C10.68 0.837646 9.39691 1.27292 8.34938 2.07604C7.30185 2.87915 6.54839 4.00529 6.20572 5.28C5.6161 5.12716 5.00067 5.10175 4.40046 5.20548C3.80025 5.3092 3.22905 5.53968 2.72492 5.88154C2.2208 6.22341 1.79533 6.6688 1.4769 7.18804C1.15846 7.70728 0.954358 8.28843 0.878203 8.89276C0.802048 9.49709 0.855587 10.1107 1.03525 10.6927C1.21491 11.2747 1.51657 11.8117 1.92013 12.268C2.32368 12.7242 2.81984 13.0892 3.37556 13.3386C3.93127 13.588 4.53376 13.7161 5.14286 13.7143H18.8571Z" />
  </svg>
);

/**
 * Icône LocationPin - Marqueur de localisation
 */
export const LocationPinIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M19.7143 8.57146C19.7143 12.84 12 23.1429 12 23.1429C12 23.1429 4.28572 12.84 4.28572 8.57146C4.28572 6.52551 5.09847 4.56335 6.54518 3.11664C7.99189 1.66993 9.95405 0.857178 12 0.857178C14.046 0.857178 16.0081 1.66993 17.4548 3.11664C18.9015 4.56335 19.7143 6.52551 19.7143 8.57146V8.57146Z" />
    <path d="M12 11.1429C13.4202 11.1429 14.5714 9.99159 14.5714 8.57143C14.5714 7.15127 13.4202 6 12 6C10.5798 6 9.42857 7.15127 9.42857 8.57143C9.42857 9.99159 10.5798 11.1429 12 11.1429Z" />
  </svg>
);

/**
 * Icône Funnel - Filtre/Entonnoir
 */
export const FunnelIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"/>
  </svg>
);

/**
 * Icône ChevronDown - Flèche vers le bas dans un cercle
 */
export const ChevronDownIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.1429 10.2856L12 15.4285L6.85715 10.2856" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84597 0.857178 0.857147 5.846 0.857147 12C0.857147 18.1541 5.84597 23.1429 12 23.1429Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône ChevronUp - Flèche vers la haut dans un cercle
 */
export const ChevronUpIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.85715 13.7144L12 8.57153L17.1429 13.7144" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84597 0.857178 0.857147 5.846 0.857147 12C0.857147 18.1541 5.84597 23.1429 12 23.1429Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Compass - Boussole pour la localisation
 */
export const CompassIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_13413)">
      <path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84597 0.857178 0.85714 5.846 0.85714 12C0.85714 18.1541 5.84597 23.1429 12 23.1429Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.8571 18.0001L16.2857 7.71436L6 11.1429L10.2857 13.7144L12.8571 18.0001Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_13413">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Loading - Trois points de chargement
 */
export const LoadingIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 14.5713C13.4202 14.5713 14.5714 13.4201 14.5714 11.9999C14.5714 10.5797 13.4202 9.42847 12 9.42847C10.5799 9.42847 9.42859 10.5797 9.42859 11.9999C9.42859 13.4201 10.5799 14.5713 12 14.5713Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 14.1426C22.1835 14.1426 23.1429 13.1833 23.1429 11.9998C23.1429 10.8163 22.1835 9.85693 21 9.85693C19.8165 9.85693 18.8571 10.8163 18.8571 11.9998C18.8571 13.1833 19.8165 14.1426 21 14.1426Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 14.1426C4.18347 14.1426 5.14286 13.1833 5.14286 11.9998C5.14286 10.8163 4.18347 9.85693 3 9.85693C1.81654 9.85693 0.857147 10.8163 0.857147 11.9998C0.857147 13.1833 1.81654 14.1426 3 14.1426Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Star - Étoile pour les événements mis en avant
 */
export const StarIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_9260)">
      <path d="M12.84 1.86847L15.5657 7.37133C15.6277 7.511 15.7252 7.63198 15.8486 7.72221C15.9719 7.81245 16.1167 7.86879 16.2686 7.88561L22.2857 8.77704C22.4599 8.79943 22.6242 8.87093 22.7593 8.98319C22.8944 9.09545 22.9948 9.24383 23.0487 9.411C23.1026 9.57818 23.1079 9.75725 23.0639 9.92729C23.0198 10.0973 22.9283 10.2513 22.8 10.3713L18.4629 14.6742C18.3522 14.7776 18.2691 14.9071 18.2212 15.0508C18.1733 15.1945 18.1621 15.3479 18.1886 15.497L19.2343 21.5485C19.2646 21.7224 19.2454 21.9012 19.1791 22.0648C19.1127 22.2283 19.0017 22.37 18.8588 22.4736C18.7159 22.5772 18.5468 22.6386 18.3708 22.6508C18.1947 22.663 18.0187 22.6256 17.8629 22.5428L12.4457 19.6799C12.307 19.6118 12.1545 19.5764 12 19.5764C11.8455 19.5764 11.693 19.6118 11.5543 19.6799L6.13715 22.5428C5.9813 22.6256 5.80532 22.663 5.62925 22.6508C5.45317 22.6386 5.28407 22.5772 5.14117 22.4736C4.99828 22.37 4.88733 22.2283 4.82095 22.0648C4.75458 21.9012 4.73544 21.7224 4.76572 21.5485L5.81143 15.4285C5.83794 15.2793 5.82673 15.1259 5.77882 14.9822C5.73092 14.8385 5.64784 14.709 5.53715 14.6056L1.14858 10.3713C1.01874 10.2481 0.927433 10.0898 0.885714 9.91569C0.843996 9.74159 0.853656 9.55913 0.913525 9.39041C0.973394 9.22169 1.0809 9.07395 1.22303 8.96508C1.36515 8.85621 1.5358 8.7909 1.71429 8.77704L7.73143 7.88561C7.88332 7.86879 8.02813 7.81245 8.15146 7.72221C8.27478 7.63198 8.3723 7.511 8.43429 7.37133L11.16 1.86847C11.2342 1.7082 11.3528 1.57251 11.5016 1.47741C11.6504 1.38232 11.8234 1.33179 12 1.33179C12.1766 1.33179 12.3496 1.38232 12.4984 1.47741C12.6472 1.57251 12.7658 1.7082 12.84 1.86847V1.86847Z" stroke="#FFD700" strokeLinecap="round" strokeLinejoin="round" fill="#FFD700"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_9260">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Accessible - Symbole d'accessibilité PMR
 */
export const AccessibleIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.7143 7.71432C15.6078 7.71432 17.1428 6.1793 17.1428 4.28575C17.1428 2.3922 15.6078 0.857178 13.7143 0.857178C11.8207 0.857178 10.2857 2.3922 10.2857 4.28575C10.2857 6.1793 11.8207 7.71432 13.7143 7.71432Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.7143 7.71436V14.5715H18.8571C19.3118 14.5715 19.7478 14.7521 20.0693 15.0736C20.3908 15.3951 20.5714 15.8311 20.5714 16.2858V23.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.42856 11.1428C8.34549 11.1439 7.28292 11.4382 6.35356 11.9943C5.4242 12.5505 4.66271 13.3478 4.14988 14.3018C3.63704 15.2558 3.39199 16.3307 3.44071 17.4127C3.48943 18.4947 3.8301 19.5433 4.4266 20.4473C5.02309 21.3513 5.85316 22.077 6.82875 22.5474C7.80433 23.0178 8.88905 23.2153 9.96783 23.1191C11.0466 23.0228 12.0792 22.6364 12.9561 22.0007C13.833 21.365 14.5215 20.5039 14.9486 19.5085" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Weather - Météo avec nuage et pluie
 */
export const WeatherIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_10253)">
      <path d="M7.28571 19.7143L8.14285 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 19.7143L15.8571 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.2857 23.1428L11.1428 21.4285" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.57144 23.1428L3.42858 21.4285" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 23.1428L18.8571 21.4285" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.8571 13.7143C19.4663 13.7161 20.0687 13.588 20.6245 13.3386C21.1802 13.0892 21.6763 12.7242 22.0799 12.268C22.4834 11.8117 22.7851 11.2747 22.9648 10.6927C23.1444 10.1107 23.198 9.49709 23.1218 8.89276C23.0456 8.28843 22.8415 7.70728 22.5231 7.18804C22.2047 6.6688 21.7792 6.22341 21.2751 5.88154C20.771 5.53968 20.1998 5.3092 19.5995 5.20548C18.9993 5.10175 18.3839 5.12716 17.7943 5.28C17.4516 4.00529 16.6982 2.87915 15.6506 2.07604C14.6031 1.27292 13.32 0.837646 12 0.837646C10.68 0.837646 9.39691 1.27292 8.34938 2.07604C7.30185 2.87915 6.54839 4.00529 6.20572 5.28C5.6161 5.12716 5.00067 5.10175 4.40046 5.20548C3.80025 5.3092 3.22905 5.53968 2.72492 5.88154C2.2208 6.22341 1.79533 6.6688 1.4769 7.18804C1.15846 7.70728 0.954358 8.28843 0.878203 8.89276C0.802048 9.49709 0.855587 10.1107 1.03525 10.6927C1.21491 11.2747 1.51657 11.8117 1.92013 12.268C2.32368 12.7242 2.81984 13.0892 3.37556 13.3386C3.93127 13.588 4.53376 13.7161 5.14286 13.7143H18.8571Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_10253">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Euro - Symbole monétaire euro
 */
export const EuroIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11476)">
      <path d="M14.5714 16.8C14.0284 17.0268 13.4456 17.1433 12.8571 17.1429C11.5504 17.085 10.32 16.511 9.43607 15.5467C8.55219 14.5825 8.08708 13.3069 8.14286 12C8.08708 10.6932 8.55219 9.41758 9.43607 8.45334C10.32 7.4891 11.5504 6.91503 12.8571 6.85718C13.3343 6.86016 13.8082 6.9353 14.2629 7.08004" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 10.2856H11.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 13.7144H11.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 23.1429C18.154 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.154 0.857178 12 0.857178C5.84594 0.857178 0.857117 5.846 0.857117 12C0.857117 18.1541 5.84594 23.1429 12 23.1429Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11476">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône User - Profil utilisateur
 * Design de silhouette de personne pour la connexion requise
 */
export const UserIcon = ({ className, ...props }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
<path d="M11.9999 13.7143C14.3669 13.7143 16.2857 11.7955 16.2857 9.42854C16.2857 7.0616 14.3669 5.14282 11.9999 5.14282C9.63301 5.14282 7.71423 7.0616 7.71423 9.42854C7.71423 11.7955 9.63301 13.7143 11.9999 13.7143Z" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M4.67999 20.4C5.44498 19.1443 6.52012 18.1066 7.80206 17.3864C9.084 16.6663 10.5296 16.2881 12 16.2881C13.4703 16.2881 14.916 16.6663 16.1979 17.3864C17.4799 18.1066 18.555 19.1443 19.32 20.4" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 23.1429C18.154 23.1429 23.1428 18.1541 23.1428 12C23.1428 5.846 18.154 0.857178 12 0.857178C5.84594 0.857178 0.857117 5.846 0.857117 12C0.857117 18.1541 5.84594 23.1429 12 23.1429Z" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

/**
 * Icône ProfileIcon - Profil avec cadre de scan
 * Design de profil utilisateur avec coins de cadre pour compléter le profil
 */
export const ProfileIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <g clipPath="url(#clip0_1545_10466)">
      <path d="M11.9999 13.7143C14.3669 13.7143 16.2857 11.7955 16.2857 9.42854C16.2857 7.0616 14.3669 5.14282 11.9999 5.14282C9.63301 5.14282 7.71423 7.0616 7.71423 9.42854C7.71423 11.7955 9.63301 13.7143 11.9999 13.7143Z" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.6743 18.4286C16.1078 17.0451 14.0899 16.2815 12 16.2815C9.91003 16.2815 7.8921 17.0451 6.32568 18.4286" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23.1429 18V21.4286C23.1429 21.8832 22.9622 22.3193 22.6408 22.6408C22.3193 22.9622 21.8832 23.1429 21.4286 23.1429H18" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 0.857178H21.4286C21.8832 0.857178 22.3193 1.03779 22.6408 1.35928C22.9622 1.68077 23.1429 2.11681 23.1429 2.57146V6.00003" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.857117 6.00003V2.57146C0.857117 2.11681 1.03773 1.68077 1.35922 1.35928C1.68071 1.03779 2.11675 0.857178 2.5714 0.857178H5.99997" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.99997 23.1429H2.5714C2.11675 23.1429 1.68071 22.9622 1.35922 22.6408C1.03773 22.3193 0.857117 21.8832 0.857117 21.4286V18" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_10466">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône ProfileEditIcon - Édition de profil avec crayon
 */
export const ProfileEditIcon = ({ className, ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_10438)">
      <path d="M8.57138 8.57146C10.7016 8.57146 12.4285 6.84456 12.4285 4.71432C12.4285 2.58408 10.7016 0.857178 8.57138 0.857178C6.44114 0.857178 4.71423 2.58408 4.71423 4.71432C4.71423 6.84456 6.44114 8.57146 8.57138 8.57146Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.99997 21.4287H0.857117V18.8572C0.870763 17.5506 1.21536 16.2687 1.85873 15.1314C2.50209 13.994 3.42323 13.0383 4.5361 12.3534C5.64897 11.6686 6.91727 11.277 8.22252 11.2152C9.52776 11.1534 10.8274 11.4234 12 12.0001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23.1428 14.5715L15.0685 22.6458L11.4171 23.143L11.9314 19.4915L19.9885 11.4172L23.1428 14.5715Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_10438">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
/**
 * Icône CardIcon - Carte bancaire/crédit
 * Design de carte de crédit pour les paiements et recharges
 */
export const CardIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21.4286 3.85718H2.57143C1.62466 3.85718 0.857147 4.62469 0.857147 5.57146V18.4286C0.857147 19.3754 1.62466 20.1429 2.57143 20.1429H21.4286C22.3753 20.1429 23.1429 19.3754 23.1429 18.4286V5.57146C23.1429 4.62469 22.3753 3.85718 21.4286 3.85718Z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.857147 9.85718H23.1429" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.2857 15.8572H18.8571" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône HandHeart - Main tenant un cœur
 * Design symbolisant l'entraide et la solidarité
 */
export const HandHeartIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M0.857117 14.5715H4.28569C5.42233 14.5715 6.51242 15.0231 7.31615 15.8268C8.11987 16.6305 8.5714 17.7206 8.5714 18.8572" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.42855 18.8572H12C12.9093 18.8572 13.7814 19.2184 14.4243 19.8614C15.0673 20.5044 15.4285 21.3764 15.4285 22.2857C15.4285 22.5131 15.3382 22.7311 15.1775 22.8918C15.0167 23.0526 14.7987 23.1429 14.5714 23.1429H0.857117" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 14.5715L8.14283 8.22865C4.40569 4.47436 9.85712 -2.79421 15 3.08579C20.1428 -2.77707 25.6457 4.49151 21.8571 8.22865L15 14.5715Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>

  </svg>
);

/**
 * Icône Edit - Crayon d'édition
 * Design de crayon pour modifier un élément
 */
export const EditIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12.8571 15.4285L7.71423 16.3543L8.57138 11.1428L18.3942 1.35425C18.5536 1.19357 18.7432 1.06604 18.9521 0.979008C19.161 0.891976 19.3851 0.847168 19.6114 0.847168C19.8377 0.847168 20.0617 0.891976 20.2707 0.979008C20.4796 1.06604 20.6692 1.19357 20.8285 1.35425L22.6457 3.17139C22.8063 3.33076 22.9339 3.52036 23.0209 3.72926C23.1079 3.93816 23.1527 4.16223 23.1527 4.38854C23.1527 4.61484 23.1079 4.83891 23.0209 5.04781C22.9339 5.25671 22.8063 5.44631 22.6457 5.60568L12.8571 15.4285Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.5714 16.2856V21.4285C20.5714 21.8831 20.3908 22.3192 20.0693 22.6406C19.7478 22.9621 19.3118 23.1428 18.8571 23.1428H2.5714C2.11675 23.1428 1.68071 22.9621 1.35922 22.6406C1.03773 22.3192 0.857147 21.8831 0.857147 21.4285V5.14275C0.857147 4.6881 1.03773 4.25206 1.35922 3.93057C1.68071 3.60908 2.11675 3.42847 2.5714 3.42847H7.71426" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Hourglass - Sablier
 * Design de sablier pour représenter le temps, l'attente ou la durée
 */
export const HourglassIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 6.00003C18 7.59133 17.3679 9.11746 16.2426 10.2427C15.1174 11.3679 13.5913 12 12 12C10.4087 12 8.88258 11.3679 7.75736 10.2427C6.63214 9.11746 6 7.59133 6 6.00003V0.857178H18V6.00003Z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 18C18 16.4087 17.3679 14.8826 16.2426 13.7574C15.1174 12.6321 13.5913 12 12 12C10.4087 12 8.88258 12.6321 7.75736 13.7574C6.63214 14.8826 6 16.4087 6 18V23.1429H18V18Z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.57141 0.857178H21.4286" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.57141 23.1428H21.4286" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Approved - Validation/Approbation
 * Design de presse-papiers avec coche pour indiquer une validation
 */
export const PublishedIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M2.5714 4.28564C2.11675 4.28564 1.68071 4.46626 1.35922 4.78775C1.03773 5.10924 0.857117 5.54527 0.857117 5.99993V21.4285C0.857117 21.8832 1.03773 22.3192 1.35922 22.6407C1.68071 22.9622 2.11675 23.1428 2.5714 23.1428H21.4285C21.8832 23.1428 22.3192 22.9622 22.6407 22.6407C22.9622 22.3192 23.1428 21.8832 23.1428 21.4285V5.99993C23.1428 5.54527 22.9622 5.10924 22.6407 4.78775C22.3192 4.46626 21.8832 4.28564 21.4285 4.28564H18" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 0.857178V7.71432" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 0.857178V7.71432" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 4.28564H14.5714" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.85712 15.4285L10.2857 18L16.2857 11.1428" strokeLinecap="round" strokeLinejoin="round"/>

  </svg>
);

/**
 * Icône Message - Bulle de message
 * Design de bulle de dialogue pour les messages et commentaires
 */
export const MessageIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M7.71429 21.4286L0.857147 23.1429L2.57143 18V2.57146C2.57143 2.11681 2.75204 1.68077 3.07354 1.35928C3.39503 1.03779 3.83106 0.857178 4.28572 0.857178H21.4286C21.8832 0.857178 22.3193 1.03779 22.6408 1.35928C22.9622 1.68077 23.1429 2.11681 23.1429 2.57146V19.7143C23.1429 20.169 22.9622 20.605 22.6408 20.9265C22.3193 21.248 21.8832 21.4286 21.4286 21.4286H7.71429Z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Chart - Graphique en barres avec flèche
 * Design de graphique avec tendance haussière pour les statistiques
 */
export const ChartIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <g clipPath="url(#clip0_1545_11532)">
      <path d="M2.12571 11.2116L21.84 2.24585" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.1543 0.857178L21.84 2.24575L20.4686 5.93146" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.7143 23.1602H18.4286V11.1602C18.4286 10.9328 18.5189 10.7148 18.6796 10.5541C18.8404 10.3933 19.0584 10.303 19.2857 10.303H21.8571C22.0845 10.303 22.3025 10.3933 22.4632 10.5541C22.624 10.7148 22.7143 10.9328 22.7143 11.1602V23.1602Z" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.1429 23.1602H9.85714V13.7316C9.85714 13.5043 9.94745 13.2862 10.1082 13.1255C10.2689 12.9647 10.487 12.8744 10.7143 12.8744H13.2857C13.513 12.8744 13.7311 12.9647 13.8918 13.1255C14.0526 13.2862 14.1429 13.5043 14.1429 13.7316L14.1429 23.1602Z" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.57143 23.1602H1.28571L1.28571 16.303C1.28571 16.0757 1.37602 15.8577 1.53676 15.6969C1.69751 15.5362 1.91553 15.4459 2.14286 15.4459H4.71428C4.94161 15.4459 5.15963 15.5362 5.32038 15.6969C5.48112 15.8577 5.57143 16.0757 5.57143 16.303L5.57143 23.1602Z" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11532">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Clock - Horloge
 * Design d'horloge pour les horaires
 */
export const ClockIcon = ({ className, ...props }) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>


  <rect width="24" height="24" fill="transparent" strokeWidth="0" />


  <g transform="translate(2,2)">
    <path d="M10 19.2858C15.1284 19.2858 19.2857 15.1284 19.2857 10.0001C19.2857 4.87171 15.1284 0.714355 10 0.714355C4.87165 0.714355 0.714294 4.87171 0.714294 10.0001C0.714294 15.1284 4.87165 19.2858 10 19.2858Z" />
    <path d="M10 6.42871V10.0001L13.6286 14.2287" />
  </g>
</svg>

);

/**
 * Icône Calendar - Calendrier
 * Design de calendrier pour les dates d'événements
 */
export const CalendarIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

/**
 * Icône Location - Marqueur de localisation simple
 * Design de pin de localisation pour les adresses
 */
export const LocationIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

/**
 * Icône Share - Partage
 * Design de flèche de partage pour les réseaux sociaux
 */
export const ShareIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

/**
 * Icône Link - Lien
 * Design de chaîne pour copier un lien
 */
export const LinkIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

/**
 * Icône Alert - Alerte/Signalement
 */
export const AlertIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

/**
 * Icône ExternalLink - Lien externe
 * Design de flèche sortant d'un carré
 */
export const ExternalLinkIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

/**
 * Icône Mail - Enveloppe de courrier
 * Design d'enveloppe pour le contact et les emails
 */
export const MailIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21.4286 3H2.57143C1.62466 3 0.857147 3.76751 0.857147 4.71429V19.2857C0.857147 20.2325 1.62466 21 2.57143 21H21.4286C22.3753 21 23.1429 20.2325 23.1429 19.2857V4.71429C23.1429 3.76751 22.3753 3 21.4286 3Z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.857147 5.14282L10.9029 13.7143C11.2109 13.9708 11.5991 14.1113 12 14.1113C12.4009 14.1113 12.7891 13.9708 13.0971 13.7143L23.1429 5.14282" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Logo - Logo Maploop
 * Design moderne avec double cercle et pointe de marqueur
 */
export const LogoIcon = ({ className, showTitle = false, scale = 1, ...props }) => {
  const baseWidth = 349;
  const baseHeight = 407;
  const width = baseWidth * scale;
  const height = baseHeight * scale;
  const darkColor = '#2894D8';
  
  return (
    <div 
      className={className} 
      style={{ 
        position: 'relative', 
        width: `${width}px`, 
        height: `${height + (showTitle ? 40 * scale : 0)}px`,
        display: 'inline-block'
      }}
      {...props}
    >
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 349 407" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <path d="M145.417 319.786H203.583L174.5 377.929L145.417 319.786Z" fill="#2894D8" stroke="#2894D8" strokeWidth="10"/>
        <path d="M174.5 319.786C254.812 319.786 319.917 254.707 319.917 174.429C319.917 94.1501 254.812 29.0715 174.5 29.0715C94.1888 29.0715 29.0835 94.1501 29.0835 174.429C29.0835 254.707 94.1888 319.786 174.5 319.786Z" fill="white" stroke="#2894D8" strokeWidth="30"/>
        <path d="M174.5 289C237.737 289 289 237.737 289 174.5C289 111.263 237.737 60 174.5 60C111.263 60 60 111.263 60 174.5C60 237.737 111.263 289 174.5 289Z" fill="white" stroke="#2894D8" strokeWidth="10"/>
      </svg>
      {showTitle && (
        <div 
          style={{
            position: 'absolute',
            top: `${height + 10 * scale}px`,
            left: '50%',
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            padding: `${4 * scale}px ${12 * scale}px`,
            fontSize: `${24 * scale}px`,
            fontWeight: '600',
            color: darkColor,
            textShadow: '-2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white, 2px 2px 0 white, -2px 0 0 white, 2px 0 0 white, 0 -2px 0 white, 0 2px 0 white, -3px -3px 0 white, 3px -3px 0 white, -3px 3px 0 white, 3px 3px 0 white, -3px 0 0 white, 3px 0 0 white, 0 -3px 0 white, 0 3px 0 white',
            maxWidth: `${300 * scale}px`,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          Maploop
        </div>
      )}
    </div>
  );
};

/**
 * Icône Copyright - Symbole de copyright
 * Design du symbole © pour les crédits et mentions légales
 */
export const CopyrightIcon = ({ className, ...props }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 9.35718C14.4732 8.83039 13.7579 8.53906 13.0157 8.53906C12.2735 8.53906 11.5582 8.83039 11.0314 9.35718C10.5046 9.88396 10.2133 10.5993 10.2133 11.3415C10.2133 12.0836 10.5046 12.799 11.0314 13.3258C11.5582 13.8526 12.2735 14.1439 13.0157 14.1439C13.7579 14.1439 14.4732 13.8526 15 13.3258" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Legal - Marteau de juge
 * Design de marteau pour les mentions légales
 */
export const LegalIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11715)">
      <path d="M0.857147 22.783H13.7143" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 22.783V18.4973H2.57143V22.783" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3486 1.71798L7.20288 7.86374C6.5334 8.53321 6.5334 9.61864 7.20288 10.2881L9.91817 13.0034C10.5876 13.6729 11.6731 13.6729 12.3425 13.0034L18.4883 6.85763C19.1578 6.18816 19.1578 5.10274 18.4883 4.43327L15.773 1.71798C15.1035 1.04851 14.0181 1.04851 13.3486 1.71798Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.4286 9.92578L23.1429 17.6401" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11715">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Terms - Document avec texte
 * Design de document pour les conditions d'utilisation
 */
export const TermsIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M23.1429 7.71429V18.8571C23.1429 19.4255 22.9171 19.9705 22.5152 20.3724C22.1134 20.7742 21.5683 21 21 21C20.4317 21 19.8866 20.7742 19.4848 20.3724C19.0829 19.9705 18.8571 19.4255 18.8571 18.8571V3.85714C18.8571 3.62981 18.7668 3.4118 18.6061 3.25105C18.4454 3.09031 18.2273 3 18 3H1.71429C1.48696 3 1.26894 3.09031 1.1082 3.25105C0.947453 3.4118 0.857147 3.62981 0.857147 3.85714V19.2857C0.857147 19.7404 1.03776 20.1764 1.35925 20.4979C1.68074 20.8194 2.11678 21 2.57143 21H21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.7143 7.28564H6V11.5714H13.7143V7.28564Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 16.7144H13.7143" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Smartphone - Téléphone avec plus
 * Design de smartphone pour l'installation PWA
 */
export const SmartphoneIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11096)">
      <path d="M12 6.85718V17.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.85715 12H17.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 0.857178H6C3.15968 0.857178 0.857147 3.15971 0.857147 6.00003V18C0.857147 20.8404 3.15968 23.1429 6 23.1429H18C20.8403 23.1429 23.1429 20.8404 23.1429 18V6.00003C23.1429 3.15971 20.8403 0.857178 18 0.857178Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11096">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône SmartphoneApp - Téléphone mobile simple
 * Design de smartphone sans symbole plus pour l'application mobile
 */
export const SmartphoneAppIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.8571 0.857178H5.14286C4.19609 0.857178 3.42857 1.62469 3.42857 2.57146V21.4286C3.42857 22.3754 4.19609 23.1429 5.14286 23.1429H18.8571C19.8039 23.1429 20.5714 22.3754 20.5714 21.4286V2.57146C20.5714 1.62469 19.8039 0.857178 18.8571 0.857178Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.7143 18.8572H13.2857" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône HandWave - Main qui salue
 * Design de main levée pour signaler son intérêt
 */
export const HandWaveIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.7771 10.0287L10.1314 3.06869C10.3001 2.7936 10.5373 2.5669 10.8197 2.41068C11.1021 2.25446 11.4201 2.17404 11.7428 2.17726V2.17726C11.997 2.16809 12.2504 2.20996 12.4881 2.3004C12.7258 2.39083 12.943 2.528 13.1268 2.7038C13.3105 2.87959 13.4572 3.09045 13.5581 3.3239C13.659 3.55735 13.7121 3.80866 13.7142 4.06298V9.05155H21.24C21.518 9.06057 21.7911 9.12835 22.0411 9.25043C22.2911 9.37251 22.5124 9.54612 22.6906 9.75986C22.8687 9.97361 22.9995 10.2226 23.0745 10.4906C23.1495 10.7585 23.1669 11.0393 23.1257 11.3144L21.7542 20.1601C21.6957 20.6329 21.4666 21.068 21.1099 21.3836C20.7532 21.6993 20.2934 21.8738 19.8171 21.8744H8.57139C8.03605 21.8765 7.50766 21.7532 7.02853 21.5144L5.79424 20.8973" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.7771 10.0288V20.846" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.71426 10.0288H5.77712V20.846H1.71426C1.48693 20.846 1.26891 20.7556 1.10817 20.5949C0.947423 20.4342 0.857117 20.2161 0.857117 19.9888V10.886C0.857117 10.6586 0.947423 10.4406 1.10817 10.2799C1.26891 10.1191 1.48693 10.0288 1.71426 10.0288V10.0288Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Icône Cross - Croix pour fermer/annuler
 * Design de croix (X) pour les actions d'annulation ou de fermeture
 */
export const CrossIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11106)">
      <path d="M23.1429 0.857178L0.857147 23.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.857147 0.857178L23.1429 23.1429" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11106">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Invoice - Facture
 * Design de document de facture avec symbole dollar
 */
export const InvoiceIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11415)">
      <path d="M14.5714 0.857178H2.57143C2.11677 0.857178 1.68074 1.03779 1.35925 1.35928C1.03776 1.68077 0.857143 2.11681 0.857143 2.57146V21.4286C0.857143 21.8833 1.03776 22.3193 1.35925 22.6408C1.68074 22.9623 2.11677 23.1429 2.57143 23.1429H21.4286C21.8832 23.1429 22.3193 22.9623 22.6408 22.6408C22.9622 22.3193 23.1429 21.8833 23.1429 21.4286V9.42861L14.5714 0.857178Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.5714 8.57146V0.857178L23.1429 9.42861H15.4286C15.2012 9.42861 14.9832 9.3383 14.8225 9.17755C14.6617 9.01681 14.5714 8.79879 14.5714 8.57146Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.71429 7.71425V5.14282" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.14286 14.5715C5.14286 15.8572 6.29143 16.2858 7.71429 16.2858C9.13714 16.2858 10.2857 16.2858 10.2857 14.5715C10.2857 12.0001 5.14286 12.0001 5.14286 9.42864C5.14286 7.71436 6.29143 7.71436 7.71429 7.71436C9.13714 7.71436 10.2857 8.36578 10.2857 9.42864" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.71429 16.2856V18.8571" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.5714 16.2856H19.7143" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11415">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Privacy - Bouclier de confidentialité avec profil
 * Design de bouclier avec utilisateur pour la confidentialité et protection des données
 */
export const PrivacyIcon = ({ className, ...props }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1545_11002)">
      <path d="M12.6171 23.0229C12.22 23.1761 11.78 23.1761 11.3828 23.0229V23.0229C8.28116 21.8067 5.61791 19.6842 3.74035 16.932C1.86278 14.1799 0.858035 10.9259 0.857117 7.59432V2.57146C0.857117 2.11681 1.03773 1.68077 1.35922 1.35928C1.68071 1.03779 2.11675 0.857178 2.5714 0.857178H21.4285C21.8832 0.857178 22.3193 1.03779 22.6408 1.35928C22.9622 1.68077 23.1428 2.11681 23.1428 2.57146V7.57718C23.1454 10.9117 22.1422 14.1694 20.2644 16.925C18.3866 19.6805 15.7215 21.8056 12.6171 23.0229V23.0229Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.9999 13.7143C14.3669 13.7143 16.2857 11.7955 16.2857 9.42854C16.2857 7.0616 14.3669 5.14282 11.9999 5.14282C9.63301 5.14282 7.71423 7.0616 7.71423 9.42854C7.71423 11.7955 9.63301 13.7143 11.9999 13.7143Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.57141 19.183C6.37577 18.2709 7.365 17.5404 8.47337 17.0401C9.58175 16.5398 10.7839 16.281 12 16.281C13.2161 16.281 14.4182 16.5398 15.5266 17.0401C16.635 17.5404 17.6242 18.2709 18.4286 19.183" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1545_11002">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Icône Invoice - Facture avec document et détails
 * Design de document avec lignes représentant une facture
 */
// export const InvoiceIcon = ({ className, ...props }) => (
//   <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
//     <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M8 13H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M8 17H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M10 9H11H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//   </svg>
// );
